const Colors = {
  FFFFFF: "#FFFFFF",
  E8E8EA: "#000e48",
  "47517b": "#47517b",
  "00b8d4": "#00b8d4"
};

export default Colors;
